/*
 * Magno: keep the chat bubbles (Shopify Inbox = <shopify-chat>, WhatsApp = a.whatsapp-contact)
 * off the product buy area. This file only toggles two classes on <body>; the hiding itself is
 * CSS in assets/magno-ux.css:
 *   body.magno-calendar-open  -> date picker is open (any screen size)
 *   body.magno-form-inview    -> the product form is on screen (used on phones only)
 * Loaded from snippets/customization-gifting-options.liquid, so it only runs on product pages.
 */
(function () {
  'use strict';
  var body = document.body;
  if (!body) return;

  // 1) Date picker open/closed. flatpickr stores its instance on the input as _flatpickr and
  //    its hooks are arrays, so we can attach without touching magno-delivery.js.
  var tries = 0;
  (function hook() {
    var input = document.querySelector('[data-date-input]');
    var fp = input && input._flatpickr;
    if (!fp) {
      if (++tries < 100) setTimeout(hook, 150);
      return;
    }
    fp.config.onOpen.push(function () { body.classList.add('magno-calendar-open'); });
    fp.config.onClose.push(function () { body.classList.remove('magno-calendar-open'); });
    if (fp.isOpen) body.classList.add('magno-calendar-open');
  })();

  // 2) Product form on screen.
  if (!('IntersectionObserver' in window)) return;
  var root = document.querySelector('[data-magno-delivery]');
  var target = root && (root.closest('form') || root);
  if (!target) return;
  new IntersectionObserver(function (entries) {
    body.classList.toggle('magno-form-inview', entries[0].isIntersecting);
  }, { threshold: 0 }).observe(target);
})();
